import { colors } from '@globals/themes/defaultTheme'
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation'
import Chip from '@mui/material/Chip'
import Typography from '@mui/material/Typography'
import { SxProps } from '@mui/material/styles'
import { T } from '@transifex/react'

const scheduleIconStyle: SxProps = {
  backgroundColor: colors.greenExtraLight,
  borderColor: 'transparent',
  '&.MuiChip-root': {
    minHeight: 32,
  },
}
const ScheduledChip = () => {
  return (
    <Chip
      label={
        <Typography variant="body1" sx={{ color: colors.greenDark }}>
          <T _str="Scheduled" />
        </Typography>
      }
      sx={scheduleIconStyle}
      icon={<InsertInvitationIcon />}
    />
  )
}

export default ScheduledChip
